// extracted by mini-css-extract-plugin
export default {"timeSlots":"TimeSlot_timeSlots__QSAow","timeSlot":"TimeSlot_timeSlot__Itv2T","active":"TimeSlot_active__7oKM2"};